import moment from "moment";
import { formatDate } from "@/utils/helpers/date-time/datetime-format";

export const billingCostHighchartsDataGenerator = (
  startPoint: string,
  dailyCosts: string,
) => {
  const values = dailyCosts.split(",").map((v) => v);

  const categories: string[] = [];
  const data: { y: number | null }[] = [];

  for (let i = 0; i < values.length; i++) {
    const newDate = moment(startPoint).add(i, "day");

    const point = values[i];
    const value = isNaN(+point) || point === "" ? null : +point;

    categories.push(formatDate(newDate, { type: "dateTimeWithComma" }));
    data.push({ y: value });
  }

  return {
    categories: categories,
    series: [{ name: "Cost", data }],
  };
};
